<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="9" xl="10">
          <span>PAGOS: INSTITUCIONES</span>
        </v-col>

        <v-col cols="12" md="6" lg="3" xl="2">
          <v-select
            v-model="tipoInstitucion"
            :items="[
              { text: 'Universidad', value: tiposInstituciones.UNIVERSIDAD },
              { text: 'Instituto', value: tiposInstituciones.INSTITUTO },
            ]"
            label="Tipo de institución"
            outlined
            dense
            hide-details
            clearable
            @change="listar"></v-select>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="9" xl="10">
        <v-btn class="ma-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <template v-if="permisosAcademicosNacional">
          <v-btn
            class="ma-1"
            title="Áreas"
            small
            :disabled="item == null"
            @click="$refs.modalAreaUniversidadRef.abrir(accionesCrud.EDITAR, item)">
            <v-icon>mdi-lan</v-icon>

            Áreas
          </v-btn>

          <v-btn
            class="ma-1"
            title="Tipos Programa"
            small
            :disabled="item == null"
            @click="$refs.modalCategoriaUniversidadRef.abrir(accionesCrud.EDITAR, item)">
            <v-icon>mdi-scatter-plot</v-icon>

            Tipos Programa
          </v-btn>
        </template>

        <v-btn
          class="ma-1"
          title="Conceptos"
          small
          :disabled="item == null"
          @click="$refs.modalConceptoUniversidadRef.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-cash</v-icon>

          Conceptos
        </v-btn>

        <v-btn
          class="ma-1"
          title="Planes Pagos"
          small
          :disabled="item == null"
          @click="$refs.modalPlanPagoUniversidad.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-format-list-bulleted</v-icon>

          Planes Pagos
        </v-btn>

        <v-btn
          class="ma-1"
          title="Tipos Lista Precio"
          small
          :disabled="item == null"
          @click="$refs.modalTipoListaPrecioRef.abrir()">
          <v-icon>mdi-format-list-bulleted-type</v-icon>

          Tipos Lista Precio
        </v-btn>

        <v-btn
          class="ma-1"
          title="Listas Precios"
          small
          :disabled="item == null"
          @click="$refs.modalListaPrecioRef.abrir()">
          <v-icon>mdi-format-list-checks</v-icon>

          Listas Precios
        </v-btn>

        <v-btn
          class="ma-1"
          title="Configuraciones"
          small
          :disabled="item == null"
          @click="$refs.modalFormularioConfiguracionesPagos.abrir()">
          <v-icon>mdi-cog</v-icon>

          Configuraciones
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoInstituciones ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalConceptoUniversidad
      ref="modalConceptoUniversidadRef"
      :nombreRecurso="nombreItem"
      @actualizarListado="listar" />

    <ModalAreaUniversidad ref="modalAreaUniversidadRef" :nombreRecurso="nombreItem1" @actualizarListado="listar" />

    <ModalCategoriaUniversidad
      ref="modalCategoriaUniversidadRef"
      :nombreRecurso="nombreItem2"
      @actualizarListado="listar" />

    <ModalPlanPagoUniversidad ref="modalPlanPagoUniversidad" :nombreRecurso="nombreItem3" @actualizarListado="listar" />

    <ModalFormularioConfiguracionesPagos
      ref="modalFormularioConfiguracionesPagos"
      nombreRecurso="Configuraciones Pagos"
      :universidadId="item?.id" />

    <ModalTipoListaPrecio ref="modalTipoListaPrecioRef" :universidad="item" />

    <ModalListaPrecio ref="modalListaPrecioRef" :universidad="item" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoInstituciones from '../components/ListadoInstituciones.vue';
import ModalConceptoUniversidad from '../components/ModalConceptoUniversidad.vue';
import InstitucionService from '../services/institucion.service';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import { TIPOS_INSTITUCIONES } from '../utils/constantes';
import ModalAreaUniversidad from '../components/ModalAreaUniversidad.vue';
import ModalCategoriaUniversidad from '../components/ModalCategoriaUniversidad.vue';
import { mapGetters } from 'vuex';
import ModalPlanPagoUniversidad from '../components/ModalPlanPagoUniversidad.vue';
import ModalFormularioConfiguracionesPagos from '../components/ModalFormularioConfiguracionesPagos.vue';
import ModalTipoListaPrecio from '../components/TipoListaPrecio/ModalTipoListaPrecio.vue';
import ModalListaPrecio from '../components/ListaPrecio/ModalListaPrecio.vue';

export default {
  name: 'SedeUniversidadLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoInstituciones,
    ModalConceptoUniversidad,
    ModalAreaUniversidad,
    ModalCategoriaUniversidad,
    ModalPlanPagoUniversidad,
    ModalFormularioConfiguracionesPagos,
    ModalTipoListaPrecio,
    ModalListaPrecio,
  },
  data() {
    return {
      nombreItem: 'Concepto Universidad',
      nombreItem1: 'Área Universidad',
      nombreItem2: 'Tipo Programa',
      nombreItem3: 'Plan Pago Universidad',
      tiposInstituciones: TIPOS_INSTITUCIONES,
      tipoInstitucion: null,
    };
  },
  mounted() {
    this.listar();
  },
  computed: {
    ...mapGetters({
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
    }),
  },
  methods: {
    listar() {
      const params = {
        tipo: this.tipoInstitucion,
      };

      this.obtenerDatosConNotificacion(InstitucionService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>